import { useEffect } from "react";
import { Grid, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  getSettings,
  getSettingsError,
  getSettingsStatus,
  selectAllSettings,
} from "../../../features/settingSlice";
import { useSelector, useDispatch } from "react-redux";
import Loading from "../../../components/loading";
import Error from "../../../components/Error";
import EditIcon from "@mui/icons-material/Edit";
import DnsIcon from "@mui/icons-material/Dns";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import AppBarSearch from "../../../global/appBarSearch";
import { useRestaurant } from "../../../hooks/RestaurantContext";
import { useTranslation } from "react-i18next";
import {
  SectionCard,
  SettingRow,
  SettingValue,
  StatusChip,
  useSettingsCardSx,
} from "../../../components/settingsLayout";

const MailManagement = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { restaurantId } = useRestaurant();
  const settings = useSelector(selectAllSettings);
  const error = useSelector(getSettingsError);
  const settingStatus = useSelector(getSettingsStatus);
  const cardSx = useSettingsCardSx();

  const handleSubmit = (event) => {
    event.preventDefault();
    navigate("modify", {
      state: {
        mail: {
          host: settings.host,
          port: settings.port,
          emailSender: settings.emailSender,
          emailName: settings.emailName,
          emailUser: settings.emailUser,
          isPasswordSet: settings.isPasswordSet,
        },
      },
    });
  };

  useEffect(() => {
    dispatch(getSettings(restaurantId));
  }, [dispatch, restaurantId]);

  return (
    <div className="main-application">
      <AppBarSearch
        handleSubmit={handleSubmit}
        title={t("pages.emailManagement")}
        buttonTitle={t("actions.editEmailSettings")}
        buttonColor={"info"}
        buttonIcon={<EditIcon />}
      />
      <main>
        <Box sx={{ my: 2 }}>
          {settingStatus === "loading" ? (
            <Loading />
          ) : settingStatus === "fetchError" ? (
            <Error>{error}</Error>
          ) : (
            settings && (
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <SectionCard
                    sx={cardSx}
                    icon={<DnsIcon color="primary" />}
                    title={t("settings.sectionSmtp")}
                  >
                    <SettingRow label={t("fields.host")}>
                      <SettingValue>{settings?.host}</SettingValue>
                    </SettingRow>
                    <SettingRow label={t("fields.port")} last>
                      <SettingValue>{settings?.port}</SettingValue>
                    </SettingRow>
                  </SectionCard>
                </Grid>
                <Grid item xs={12} md={6}>
                  <SectionCard
                    sx={cardSx}
                    icon={<AlternateEmailIcon color="primary" />}
                    title={t("settings.sectionSender")}
                  >
                    <SettingRow label={t("fields.emailConfig")}>
                      <SettingValue>{settings?.emailUser}</SettingValue>
                    </SettingRow>
                    <SettingRow label={t("fields.emailDisplay")}>
                      <SettingValue>{settings?.emailSender}</SettingValue>
                    </SettingRow>
                    <SettingRow label={t("fields.displayName")}>
                      <SettingValue>{settings?.emailName}</SettingValue>
                    </SettingRow>
                    <SettingRow label={t("fields.password")} last>
                      <StatusChip
                        active={Boolean(settings?.isPasswordSet)}
                        activeLabel={t("fields.passwordConfigured")}
                        inactiveLabel={t("fields.passwordMissing")}
                      />
                    </SettingRow>
                  </SectionCard>
                </Grid>
              </Grid>
            )
          )}
        </Box>
      </main>
    </div>
  );
};

export default MailManagement;
